import sharedoSettings from "@/services/sharedo/sharedoSettingsService";
import auth from "@/services/auth/authService";
import tokenStorage from "@/services/auth/tokenStorageService";
import global from "@/global";

const defaultResolver = response => response.json();

const logOutAndRedirct = () => {
    const store = global.getStore();
    const router = global.getRouter();

    tokenStorage.clear();
    store.commit("loggedOut");
    router.push("/");
}

const makeRequest = (endpoint, request, resolve, reject, attempt = 1, resolver = defaultResolver) => {

    var settings = sharedoSettings.get();
    
    // Normalize endpoint - remove leading slash if present to avoid double slashes
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

    return fetch(`${settings.sharedoApi}${normalizedEndpoint}`, request).then(response => {
        if (response.ok) {
            resolve(resolver(response));
        } else if (response.status === 401) {
            if (attempt === 1) {
                auth.renewTokens().then(newAccessToken => {
                    request.headers["Authorization"] = `Bearer ${newAccessToken}`;
                    makeRequest(endpoint, request, resolve, reject, attempt + 1, resolver)
                }, logOutAndRedirct)
            } else {
                logOutAndRedirct();
            }
        } else {
            reject(response.statusText);
        }
    }, error => reject(error));
};

const get = endpoint => new Promise((resolve, reject) => {
    const accessToken = tokenStorage.getAccessToken();
    if (!accessToken) {
        reject("Not authorzied.");
    }

    const request = {
        method: "GET",
        cache: "no-cache",
        headers: {
            "Authorization": `Bearer ${accessToken}`,
            "Accept": "application/json"
        }
    };

    makeRequest(endpoint, request, resolve, reject);
});

const getBlob = endpoint => new Promise((resolve, reject) => {
    const accessToken = tokenStorage.getAccessToken();
    if (!accessToken) {
        reject("Not authorzied.");
    }

    const request = {
        method: "GET",
        cache: "no-cache",
        headers: {
            "Authorization": `Bearer ${accessToken}`
        }
    };

    makeRequest(endpoint, request, resolve, reject, 1, response => response.blob());
});

const post = (endpoint, payload) => new Promise((resolve, reject) => {
    const accessToken = tokenStorage.getAccessToken();
    if (!accessToken) {
        reject("Not authorzied.");
    }

    const request = {
        method: "POST",
        cache: "no-cache",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`,
            "Accept": "application/json"
        }
    };

    makeRequest(endpoint, request, resolve, reject);
});

export default {
    get,
    getBlob,
    post,
};